import { Injectable } from '@angular/core';
import { AlertController, ToastController, LoadingController,ActionSheetController} from '@ionic/angular';
@Injectable({
  providedIn: 'root'
})
export class UiService {

  private loading: any = null;;
  constructor(public alertController: AlertController,public toastController: ToastController,private loadingCtrl: LoadingController,
    public actionSheetController: ActionSheetController) {
  }

  async alertaIngormativa(message: string){

    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      message,
      buttons: ['OK']
    });
    await alert.present();
  }
  async notificacion(message,icon,header) {
    const toast = await this.toastController.create({
      header,
      icon,
      message,
      duration: 3000,
      position:'top'
    });
    toast.present();
  }

     async showLoading(message) {
     this.loading = await this.loadingCtrl.create({
      message,
      cssClass: 'custom-loading',
      spinner: 'circles'
    });
    return this.loading.present();
  }

  hiddenLoading(){
    if(this.loading !== null){
       this.loading.dismiss();
       this.loading = null;
    }
  }



}
